import { render, staticRenderFns } from "./DamageDialog.vue?vue&type=template&id=478545e1&scoped=true&"
import script from "./DamageDialog.vue?vue&type=script&lang=js&"
export * from "./DamageDialog.vue?vue&type=script&lang=js&"
import style0 from "./DamageDialog.vue?vue&type=style&index=0&id=478545e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478545e1",
  null
  
)

export default component.exports